// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3PlSM","footer":"ModalError_footer__2IrNA"};